import AdsPage from '@frontend/modules/public/ads/AdsPage'
import LogoutPage from '@frontend/modules/public/auth/LogoutPage'
import ErrorPage from '@frontend/modules/public/errors/ErrorPage'
import HomePage from '@frontend/modules/public/home/HomePage'
import ServicesPage from '@frontend/modules/public/services/ServicesPage'
import {lazy} from 'react'

// Выносим часть страниц в чанки для облегчения базового бандла.
export const AppPages = {
    HomePage,
    AdsPage,
    ServicesPage,
    AdDetailsPage: lazy(() => import('@frontend/modules/public/ads/AdDetailsPage')),
    ExecutorDetailsPage: lazy(() => import('@frontend/modules/public/services/ExecutorDetailsPage')),

    SellerDetailsPage: lazy(() => import('@frontend/modules/public/seller_info/SellerDetailsPage')),
    SellerReviewsPage: lazy(() => import('@frontend/modules/public/seller_info/SellerReviewsPage')),
    ServiceRequesterDetailsPage: lazy(() => import('@frontend/modules/public/service_requester_info/ServiceRequesterDetailsPage')),
    ServiceOwnerDetailsPage: lazy(() => import('@frontend/modules/public/service_owner_info/ServiceOwnerDetailsPage')),

    AboutPage: lazy(() => import('@frontend/modules/public/about_us/AboutPage')),
    SupportPage: lazy(() => import('@frontend/modules/public/support/SupportPage')),
    SupportCategoryPage: lazy(() => import('@frontend/modules/public/support/SupportCategoryPage')),
    SupportArticlePage: lazy(() => import('@frontend/modules/public/support/SupportArticlePage')),
    SupportTicketsPage: lazy(() => import('../modules/private/support_tickets/SupportTicketsPage')),
    SupportTicketDetailsPage: lazy(() => import('../modules/private/support_tickets/SupportTicketDetailsPage')),
    ContactSupportFormPage: lazy(() => import('@frontend/modules/public/support/ContactSupportFormPage')),
    RulesAndDocumentsPage: lazy(() => import('@frontend/modules/public/support/RulesAndDocumentsPage')),
    RulesAndDocumentsArticlePage: lazy(() => import('@frontend/modules/public/support/RulesAndDocumentsArticlePage')),

    NewsPage: lazy(() => import('@frontend/modules/public/news/NewsPage')),
    NewsItemDetailsPage: lazy(() => import('@frontend/modules/public/news/NewsItemDetailsPage')),

    LoginPage: lazy(() => import('@frontend/modules/public/auth/LoginPage')),
    LogoutPage,
    RegistrationPage: lazy(() => import('@frontend/modules/public/registration/RegistrationPage')),

    MyAdsPage: lazy(() => import('../modules/private/ads/MyAdsPage')),
    AdFormPage: lazy(() => import('@frontend/modules/private/ad_form/AdFormPage')),
    AdsImportPage: lazy(() => import('@frontend/modules/private/ads_import/AdsImportPage')),
    MyExecutorsPage: lazy(() => import('@frontend/modules/private/executors/MyExecutorsPage')),
    ExecutorFormPage: lazy(() => import('@frontend/modules/private/executor_form/ExecutorFormPage')),

    FavoritesPage: lazy(() => import('@frontend/modules/private/favourites/FavoritesPage')),
    SubscriptionsPage: lazy(() => import('../modules/private/subscriptions/SubscriptionsPage')),
    NotificationsPage: lazy(() => import('../modules/private/notifications/NotificationsPage')),
    MyReviewsPage: lazy(() => import('../modules/private/reviews/MyReviewsPage')),
    SettingsPage: lazy(() => import('../modules/private/settings/SettingsPage')),
    ChatsPage: lazy(() => import('../modules/private/chats/ChatsPage')),

    PaidServicesPriceListPage: lazy(() => import('../modules/private/paid_services/PaidServicesPriceListPage')),
    TransactionsPage: lazy(() => import('../modules/private/transactions/TransactionsPage')),
    OrderDetailsPage: lazy(() => import('../modules/private/orders/OrderDetailsPage')),

    ClientSurveyFormPage: lazy(() => import('../modules/private/client_survey/ClientSurveyFormPage')),
    ClientContractPage: lazy(() => import('@frontend/modules/private/advance_payments/ClientContractPage')),
    ClientSurveySelectAdForAdvancePage: lazy(() => import('../modules/private/client_survey/ClientSurveySelectAdForAdvancePage')),
    ClientSurveyRequestAdvanceForAdPage: lazy(() => import('../modules/private/client_survey/ClientSurveyRequestAdvanceForAdPage')),
    ClientContractReworkPage: lazy(() => import('@frontend/modules/private/advance_payments/ClientContractReworkPage')),
    ClientContractVerificationPage: lazy(() => import('@frontend/modules/private/advance_payments/ClientContractVerificationPage')),
    ClientContractBankAccountPage: lazy(() => import('@frontend/modules/private/advance_payments/ClientContractBankAccountPage')),

    QuickAdvanceLandingPage: lazy(() => import('../modules/public/quick_advance/QuickAdvanceLandingPage')),
    QuickAdvanceSurveyPage: lazy(() => import('../modules/public/quick_advance/QuickAdvanceSurveyPage')),
    QuickAdvanceAdSelectionPage: lazy(() => import('../modules/public/quick_advance/QuickAdvanceAdSelectionPage')),
    QuickAdvanceRequestPage: lazy(() => import('../modules/public/quick_advance/QuickAdvanceRequestPage')),

    ErrorPage,
    UiDemoPage: process.env.NODE_ENV === 'production' ? null : lazy(() => import('../modules/ui-demo/UiDemoPage')),
}
